module.exports = {"name":"xterm.terminado","main":"terminado.js","private":true}


//////////////////
// WEBPACK FOOTER
// ./~/xterm/lib/addons/terminado/package.json
// module id = 14
// module chunks = 0